import ChatGptHomePage from "./pages/chat_gpt_home_page";

function App() {
  return <ChatGptHomePage />;
}

export default App;
